<template>
  <!-- 弹出框 -->
  <a-modal
    v-model="modal.visible"
    :title="modal.title"
    @ok="handleOk"
    @cancel="cancel"
    :confirm-loading="confirmLoading"
  >
    <a-form-model
      ref="ruleForm"
      :model="formData"
      :rules="rules"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 18 }"
    >
      <a-form-model-item
        label="邮箱"
        prop="email"
        v-if="formData.type == 'email'"
        ><a-input v-model="formData.email"
      /></a-form-model-item>

      <a-form-model-item
        label="手机号"
        prop="mobile"
        v-if="formData.type == 'mobile'"
        ><a-input v-model="formData.mobile"
      /></a-form-model-item>

      <a-form-model-item
          label="图片验证码"
          prop="captchaCode"
      >
        <div style="display: flex;flex-direction: row;">
          <a-input v-model="formData.captchaCode" :maxLength="20" />
          <img width="150" height="32" style="margin-left: 5px;" :src="caImageSrc"/>
          <a-button @click.stop.prevent="getCaImage">刷新</a-button>
        </div>
      </a-form-model-item>
      <a-form-model-item label="验证码" prop="verifyCode">
        <div style="display: flex;flex-direction: row;">
          <a-input v-model="formData.verifyCode" :maxLength="20" />
          <a-button
            :disabled="state.smsSendBtn"
            @click.stop.prevent="getCaptcha"
            v-text="(!state.smsSendBtn && '获取验证码') || state.time + ' s'"
          ></a-button>
        </div>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "BindInfo",
  data() {
    let handleMobile = (rule, value, callback) => {
      const mobileRegex = /^[1]([3-9])[0-9]{9}$/.test(value);
      if (!mobileRegex) {
        callback("请输入正确的手机号");
      }
      callback();
    };
    let handleEmail = (rule, value, callback) => {
      const emailRegex = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(
        value
      );
      if (!emailRegex) {
        callback("请输入正确的邮箱");
      }
      callback();
    };
    return {
      confirmLoading: false,
      caImageSrc: "",
      //弹出框参数
      modal: {
        visible: false,
        title: ""
      },
      //form
      formData: {
        type: "mobile"
      },
      //form rules
      rules: {
        mobile: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "change"
          },
          { validator: handleMobile, trigger: "blur" }
        ],
        email: [
          {
            required: true,
            message: "请输入邮箱",
            trigger: "change"
          },
          { validator: handleEmail, trigger: "blur" }
        ],
        captchaCode: [
          {
            required: true,
            message: "请输入图片验证码",
            trigger: "change"
          }
        ],
        verifyCode: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "change"
          }
        ]
      },
      userInfo: null,
      state: {
        time: 60,
        smsSendBtn: false,
        verifyNo: ""
      }
    };
  },
  created() {
    this.userInfo = this.$store.getters.userInfo;
  },
  methods: {
    ...mapActions(["SetUserInfo"]),
    show(type) {
      this.formData.type = type;
      this.modal.title = type == "mobile" ? "绑定手机" : "绑定邮箱";
      this.modal.visible = true;
      this.getCaImage();
    },
    cancel() {
      this.$refs.ruleForm.resetFields();
      this.formData = {
        type: "mobile"
      };
      this.confirmLoading = false;
      this.modal.visible = false;
    },
    /**
     * 保存
     */
    handleOk() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          // this.confirmLoading = true;
          let param = {};
          param.userNo = this.userInfo.userNo;
          param.bindType = this.formData.type;
          param.checkType = "verify_code";
          if (this.formData.type == "email") {
            param.email = this.formData.email;
          } else if (this.formData.type == "mobile") {
            param.mobile = this.formData.mobile;
          }
          param.verifyNo = this.state.verifyNo;
          param.verifyCode = this.formData.verifyCode;
          this.$http.loginBksApi.bindUserInfo(param).then(res => {
            if (res && res.result == 0) {
              this.$message.success(res.msg);
              if (this.formData.type == "email") {
                this.userInfo.email = param.email;
              } else if (this.formData.type == "mobile") {
                this.userInfo.mobile = param.mobile;
              }
              this.SetUserInfo(this.userInfo);
              this.$emit("success");
              this.cancel();
            } else {
              this.confirmLoading = false;
            }
          });
        } else {
          this.confirmLoading = false;
        }
      });
    },
    /**
     * 发送验证码
     * @param {Object}
     */
    getCaptcha(e) {
      e.preventDefault();
      if (this.formData.type == "email" && !this.formData.email) {
        this.$message.error("请输入邮箱");
        return;
      }
      if (this.formData.type == "mobile" && !this.formData.mobile) {
        this.$message.error("请输入手机号");
        return;
      }
      this.state.smsSendBtn = true;
      const interval = window.setInterval(() => {
        if (this.state.time-- <= 0) {
          this.state.time = 60;
          this.state.smsSendBtn = false;
          window.clearInterval(interval);
        }
      }, 1000);

      const hide = this.$message.loading("验证码发送中..", 0);
      const param = {};
      if (this.formData.type == "email") {
        param.account = this.formData.email;
        param.accountType = "EMAIL";
        param.verifyType = "bind_email";
      } else if (this.formData.type == "mobile") {
        param.account = this.formData.mobile;
        param.accountType = "SMS";
        param.verifyType = "bind_mobile";
      } else {
        this.$message.error("不支持的验证码类型");
        setTimeout(hide, 1);
        clearInterval(interval);
        this.state.time = 60;
        this.state.smsSendBtn = false;
        return;
      }
      param.isCheckUser = "T";
      param.captchaCode = this.formData.captchaCode;
      this.$http.loginBksApi
        .sendVerify(param)
        .then(res => {
          setTimeout(hide, 1);
          if (res && res.result == 0) {
            this.state.verifyNo = res.resultObject;
            this.$notification["success"]({
              message: "提示",
              description: "验证码发送成功",
              duration: 8
            });
          } else {
            setTimeout(hide, 1);
            clearInterval(interval);
            this.state.time = 60;
            this.state.smsSendBtn = false;
          }
        })
        .catch(err => {
          setTimeout(hide, 1);
          clearInterval(interval);
          this.state.time = 60;
          this.state.smsSendBtn = false;
        });
    },
    async getCaImage(){
      let imgUrl = await this.$http.loginBksApi.getCaptcha();
      if(imgUrl){
        this.caImageSrc = imgUrl;
      }
    }
  }
};
</script>

<style></style>
